import { RoutePath } from '@core/types/route';
import Paragraph from '@shared/components/Paragraph';
import { FC, useEffect, useRef, useState } from 'react';

import { SectionGold } from '../../components/ColoredSection';
import GenericLayout from '../../components/GenericLayout';
import RouteButton from '../../components/RouteButton';
import { PageImageSection, PageImg } from '../../styled/self-defense';
import { COLOR } from '../../types/theme';
import Alltag from './Alltag';
import Extrem from './Extrem';

const SelfDefense: FC = () => {
  const [left, setLeft] = useState<number>(-450);
  const sectionRef = useRef<HTMLDivElement>(null);
  const imageRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const align = () => {
      const section = sectionRef.current;
      const image = imageRef.current;

      if (section && image) {
        const sectionW = parseInt(getComputedStyle(section).width);
        setLeft(sectionW > 800 ? -((2000 - sectionW) >> 1) : -450);
      }
    };

    align();

    window.addEventListener('resize', align);
    return () => {
      window.removeEventListener('resize', align);
    };
  }, []);

  return (
    <GenericLayout title='Selbstverteidigung'>
      <PageImageSection ref={sectionRef}>
        <PageImg
          alt='Alexander Solovev demonstriert Schmerztechniken'
          ref={imageRef}
          src='/img/header-solovev-defense-kampfkunst.jpg'
          sx={{ left: `${left}px` }}
        />
      </PageImageSection>

      <Extrem />

      <SectionGold>
        <Paragraph center>
          Derzeit unterrichten wir "Selbstverteidigung Extrem" im Rahmen unseres VIP-Programms.
        </Paragraph>

        <Paragraph center>
          <RouteButton
            background={COLOR.White}
            bold
            color={COLOR.Gold2}
            href={RoutePath.KampfkunstVip}
          >
            Zum VIP-Programm
          </RouteButton>
        </Paragraph>
      </SectionGold>

      <Alltag />
    </GenericLayout>
  );
};

export default SelfDefense;
